interface Props {
  width?: string | number;
  height?: string | number;
  stroke?: string;
}

const Envelope = ({ width = 200, height = 154, stroke = '#cacacb' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    version="1.1"
    viewBox="0 0 52.917 40.935"
  >
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse">
        <path d="M0 60h60V0H0z" />
      </clipPath>
    </defs>
    <g
      fill="none"
      stroke={stroke}
      strokeDasharray="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeOpacity="1"
      strokeWidth="1.751"
    >
      <path
        d="M72.62 114.968h45.26a2.961 2.961 0 012.953 2.952V151.2a2.961 2.961 0 01-2.953 2.952H72.62a2.961 2.961 0 01-2.953-2.952V117.92a2.961 2.961 0 012.953-2.952z"
        opacity="1"
        stopOpacity="1"
        transform="translate(-68.792 -114.092)"
      />
      <path
        d="M117.898 115.053l-21.022 21.022a2.306 2.306 0 01-3.252 0l-21.022-21.022"
        opacity="1"
        stopOpacity="1"
        transform="translate(-68.792 -114.092)"
      />
    </g>
  </svg>
);

export default Envelope;
